import { Link } from "react-router-dom";
import { Home, Building2, Factory, Landmark, Compass, PenTool, KeyRound, Package, ArrowUpRight } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { SERVICES } from "@/data/content";

const ICONS = { Home, Building2, Factory, Landmark, Compass, PenTool, KeyRound, Package };
const SLUGS = ["residential", "commercial", "industrial", "mega-projects", "engineering", "architecture", "turnkey-construction", "building-materials"];

export const ServicePillars = () => (
    <section id="services" data-testid="services-section" className="relative overflow-hidden bg-omsivo-paper py-24 lg:py-36">
        <div className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-10">
            <div className="flex flex-wrap items-end justify-between gap-6">
                <SectionHeading
                    id="services-heading"
                    overline="What We Build"
                    title={<>Eight pillars. <span className="text-flame-dark">One partner.</span></>}
                    description="From a single home to a master-planned township — OMSIVO delivers construction, engineering, design and development under one roof. Open any pillar for the full service page."
                />
            </div>

            <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4">
                {SERVICES.map((s, i) => {
                    const Icon = ICONS[s.icon];
                    return (
                        <Reveal key={s.title} delay={0.05 * (i % 4)} className="h-full">
                            <Link to={`/services/${SLUGS[i]}`} data-testid={`service-card-${i}`}
                                className="lift-card group flex h-full flex-col rounded-2xl border border-omsivo-navy/10 bg-white p-7">
                                <div className="flex items-start justify-between">
                                    <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-omsivo-navy/5 text-omsivo-blue transition-colors group-hover:bg-flame group-hover:text-white">
                                        <Icon className="h-6 w-6" />
                                    </div>
                                    <span className="font-mono text-[10px] text-slate-300">{String(i + 1).padStart(2, "0")}</span>
                                </div>
                                <h3 className="mt-6 font-display text-base font-extrabold uppercase leading-snug tracking-[0.06em] text-omsivo-navy">
                                    {s.title}
                                </h3>
                                <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.text}</p>
                                <ul className="mt-4 space-y-1.5 border-t border-omsivo-navy/8 pt-4">
                                    {s.items.slice(0, 3).map((it) => (
                                        <li key={it} className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.12em] text-slate-500">
                                            <span className="h-1 w-1 rounded-full bg-flame" />{it}
                                        </li>
                                    ))}
                                    <li className="font-mono text-[10px] uppercase tracking-[0.12em] text-slate-400">
                                        + {s.items.length - 3} more
                                    </li>
                                </ul>
                                <span className="mt-auto flex items-center gap-2 pt-6 font-display text-xs font-bold uppercase tracking-[0.14em] text-omsivo-blue transition-colors group-hover:text-flame-dark">
                                    Explore Service <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                                </span>
                            </Link>
                        </Reveal>
                    );
                })}
            </div>
        </div>
    </section>
);
